import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Form,
  Input,
  DatePicker,
} from 'antd';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import Select from 'components/Select';
import { toMoment, toUpper } from 'utils/normalizers';

const PlacaGPM = ({ disabled, historialDePlacas }) => {
  const formInstance = Form.useFormInstance();
  const placa_manual = Form.useWatch('placa_manual', formInstance);
  const placa = historialDePlacas[historialDePlacas.length - 1];

  useEffect(() => {
    setTimeout(() => {
      if (disabled) {
        const placaAnterior = historialDePlacas[historialDePlacas.length - 2];
        if (placa) {
          formInstance.setFieldsValue({
            placa_manual: true,
            numero_de_placa: placa.numero_de_placa,
            fecha_expedicion_placa: toMoment(placa.fecha_expedicion_placa),
            fecha_de_baja: toMoment(placaAnterior?.fecha_de_baja),
          });
        }
      }
    });
  }, []);

  const breakpoints = disabled ? { span: 0 } : { xs: 24, sm: 24, md: 8 };

  const rules = {
    required: [{ required: true }],
    numero_de_placa: [
      { required: true },
      {
        validator: async (_, value) => {
          if (value === placa?.numero_de_placa) {
            throw new Error('No puede ingresar el número de placa actual');
          }
        },
      },
    ],
  };

  return (
    <>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Col {...breakpoints}>
        <Form.Item
          label="¿Capturar placa manualmente?"
          name="placa_manual"
        >
          <Select disabled={disabled} trueFalse={['Si', 'No, consultar información desde finanzas']} />
        </Form.Item>
      </Col>
      {placa_manual && (
        <>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Número de placa vigente"
              name="numero_de_placa"
              rules={rules.numero_de_placa}
              normalize={toUpper}
            >
              <Input disabled={disabled} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Fecha de expedición de placa vigente"
              name="fecha_expedicion_placa"
              rules={rules.required}
            >
              <DatePicker
                disabled={disabled}
                placeholder=""
                format={DATE_FRONTEND_FORMAT}
                disabledDate={(d) => d.isAfter(toMoment(new Date()))}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8}>
            <Form.Item
              label="Fecha de baja de placa anterior"
              name="fecha_de_baja"
            >
              <DatePicker
                disabled={disabled}
                placeholder=""
                format={DATE_FRONTEND_FORMAT}
                disabledDate={(d) => d.isAfter(toMoment(new Date()))}
              />
            </Form.Item>
          </Col>
        </>
      )}
    </>
  );
};

PlacaGPM.propTypes = {
  disabled: PropTypes.bool,
  historialDePlacas: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

PlacaGPM.defaultProps = {
  disabled: false,
};

export default PlacaGPM;
